import axios from "axios";
import i18n from "locales/i18n";
// import { useDispatch } from "react-redux";
// import { LOGOUT } from "store/reducers/auth";
import { getAccessTokenFromRedux, getRefreshTokenFromRedux } from './authService';
import { dispatch } from "../../store";
import { LOGIN } from "store/reducers/auth";
// import { useLocation } from "react-router-dom";


// ✅ 공통 인터셉터 함수
let isRefreshing = false;
let failedQueue = [];

function processQueue(error, token = null) {
  failedQueue.forEach(promise => {
    if (error) {
      promise.reject(error);
    } else {
      promise.resolve(token);
    }
  });
  failedQueue = [];
}

function applyInterceptors(instance) {
  instance.interceptors.request.use(
    config => {
      // const token = getAccessToken();
      const token = getAccessTokenFromRedux();
      // console.log(token)
      if (token) {
         let payload = token.substring(token.indexOf('.')+1,token.lastIndexOf('.'));
        //  console.log(payload)
        //  let decodingInfo = base64.decode(payload);
        //  console.log("authtoken decode ", decodingInfo)
        //  let decodingInfoJson = JSON.parse(decodingInfo);
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
        );
        let decodingInfoJson = JSON.parse(jsonPayload);
        // console.log("AccessTokenByExpired expiredTime : ", (decodingInfoJson.exp - (Date.now() / 1000))/60)
        // console.log("AccessTokenByExpired expiredTime : ", (decodingInfoJson.exp - (Date.now() / 1000))/60)
        config.headers.Authorization = `Bearer ${token}`;
        config.headers['Accept-Language'] = i18n.language;
      }
      return config;
    },
    error => Promise.reject(error)
  );

  instance.interceptors.response.use(
    response => response,
    async error => {
      const originalRequest = error.config;
// console.log(error.response);
// console.log(originalRequest);
      if ((error.response?.status === 401 || error.response?.status === 403) && !originalRequest._retry) {
        originalRequest._retry = true;

        console.log(error.response.data.code);
        console.log(error.response.data.message);
        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          }).then(token => {
            // console.log(token)
            originalRequest.headers.Authorization = `Bearer ${token}`;
            originalRequest.headers['Accept-Language'] = i18n.language;
            return instance(originalRequest);
          });
        }

        isRefreshing = true;
        try {
          // const refreshToken = getRefreshToken();
          const refreshToken = getRefreshTokenFromRedux();
          const { data } = await axios.post(process.env.REACT_APP_API_URL+'/api/public/login/refresh', { refresh_token:refreshToken });
          // console.log(data)
          if (data.id_token) {
            dispatch(LOGIN({accessToken:data.id_token, refreshToken:data.refresh_token}));
            // dispatch(LOGIN(data));//{accessToken:res.data.id_token}
            processQueue(null, data.id_token);

            originalRequest.headers.Authorization = `Bearer ${data.id_token}`;
            originalRequest.headers['Accept-Language'] = i18n.language;
            return instance(originalRequest);
          // } else {
          //   processQueue(data.error_message, null);
          //   console.log(data.error_message)
          //   window.location.href = '/auth/logoutProcess';
          //   return Promise.reject(data.error_message);
          }
        } catch (refreshError) {
          processQueue(refreshError, null);
          console.log(refreshError)
          window.location.href = '/auth/logoutProcess';
          return Promise.reject(refreshError);
        } finally {
          isRefreshing = false;
        }
      }

      return Promise.reject(error);
    }
  );
}

// ✅ 공통 axios 인스턴스
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
applyInterceptors(axiosInstance);

// ✅ 개별 인스턴스 생성 함수
function createCustomAxios(options = {}) {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    ...options,
  });
  applyInterceptors(instance);
  return instance;
}

// ✅ 다양한 요청용 인스턴스 정의
export const customAxios = createCustomAxios({
  headers: {
    'Content-Type': 'application/json; charset=UTF-8',
    Accept: 'application/json',
  },
});

export const customPatchAxios = createCustomAxios({
  headers: {
    'Content-Type': 'application/merge-patch+json; charset=UTF-8',
    Accept: 'application/json',
  },
});

export const customFileAxios = createCustomAxios({
  headers: {
    'Content-Type': 'multipart/form-data',
    Accept: 'application/json',
  },
});

export const customFileDownAxios = createCustomAxios({
  responseType: 'blob',
});

// ✅ 로그인 전 요청 (토큰 필요 없음)
export const customLoginAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8',
    Accept: 'application/json',
  },
});


 

export default axiosInstance;